var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import { formatValidationPasswordErrors } from "../../utils/validations";
import { resetPasswordSchema } from "../../schemas/resetPasswordSchema";
import { useAuth } from "../../hooks/useAuth";
import { Card } from "../../components/modules/Card";
import Recaptcha from "../../components/modules/Recaptcha";
import { Form } from "../../components/elements/Form";
import { InputBaseStrongPassword } from "../../components/modules/InputBaseStrongPassword";
import { Button } from "../../components/elements/Button";
import { Text } from "../../components/elements/Text";
import { Container, Wrapper, ContentContainer, InfoContainer, FormContainer, } from "./styles";
export function ResetPassword() {
    var _a = useAuth(), loading = _a.loading, erroHandler = _a.erroHandler, numberOfAttempts = _a.numberOfAttempts, onResetPassword = _a.onResetPassword;
    var token = useParams().token;
    var _b = __read(useSearchParams(), 1), searchParams = _b[0];
    var _c = __read(useState(""), 2), confirmPasswordMessage = _c[0], setConfirmPasswordMessage = _c[1];
    var _d = __read(useState(""), 2), password = _d[0], setPassword = _d[1];
    var _e = __read(useState([]), 2), strongErrors = _e[0], setStrongErrors = _e[1];
    if (typeof token === "undefined") {
        return _jsx(Navigate, { replace: true, to: "/senha/email" });
    }
    function onSubmit(formData) {
        return __awaiter(this, void 0, void 0, function () {
            var email, decodedEmail, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = searchParams.get("email");
                        decodedEmail = decodeURIComponent(String(email));
                        body = __assign(__assign({}, formData), { token: token, email: decodedEmail });
                        return [4 /*yield*/, onResetPassword(body)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        function validate(password) {
            return __awaiter(this, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, resetPasswordSchema.validate({
                                    password: password,
                                }, { abortEarly: false })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            setStrongErrors(err_1 === null || err_1 === void 0 ? void 0 : err_1.errors.slice(2));
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        validate(password);
    }, [password]);
    var handleConfirmPasswordMessage = function (_a) {
        var password = _a.password, password_confirmation = _a.password_confirmation;
        if (password !== "" &&
            password_confirmation !== "" &&
            password !== password_confirmation) {
            setConfirmPasswordMessage("As senhas não conferem.");
        }
        else {
            setConfirmPasswordMessage("");
        }
    };
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsxs(ContentContainer, { children: [_jsx(InfoContainer, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "Crie sua nova senha" })) }), _jsx(Form, __assign({ schema: resetPasswordSchema, onSubmit: onSubmit, mode: "onChange", reValidateMode: "onChange", criteriaMode: "all" }, { children: function (_a) {
                                var _b, _c, _d, _e;
                                var control = _a.control, _f = _a.formState, errors = _f.errors, isDirty = _f.isDirty;
                                var _g = useWatch({
                                    control: control,
                                }), password = _g.password, password_confirmation = _g.password_confirmation;
                                var validations = formatValidationPasswordErrors(strongErrors, password || "", isDirty, (_c = (_b = errors === null || errors === void 0 ? void 0 : errors.password) === null || _b === void 0 ? void 0 : _b.types) === null || _c === void 0 ? void 0 : _c.matches);
                                handleConfirmPasswordMessage({
                                    password: password || "",
                                    password_confirmation: password_confirmation || "",
                                });
                                return (_jsxs(FormContainer, { children: [_jsx(Box, __assign({ marginBottom: "3rem" }, { children: _jsx(InputBaseStrongPassword, { name: "password", label: "Senha", value: password, onChange: function (e) { return setPassword(e.target.value); }, disabled: loading, control: control, errorText: (_d = errors.password) === null || _d === void 0 ? void 0 : _d.message, validations: validations }) })), _jsx(Box, __assign({ marginBottom: "2.5rem" }, { children: _jsx(InputBaseStrongPassword, { name: "password_confirmation", errorText: ((_e = errors.password_confirmation) === null || _e === void 0 ? void 0 : _e.message) ||
                                                    confirmPasswordMessage, label: "Confirme sua senha", disabled: loading, control: control }) })), !!erroHandler && (_jsx(Box, __assign({ marginBottom: "1.5rem" }, { children: _jsx(Text, __assign({ textStyle: "caption1", color: "blood" }, { children: erroHandler })) }))), _jsx(Button, { type: "submit", children: "Continuar", colorScheme: "gradient", buttonVariant: "h2", disabled: loading, loading: loading }), _jsx(Box, __assign({ marginTop: "2.5rem" }, { children: _jsx(Recaptcha, { numberOfAttempts: numberOfAttempts }) }))] }));
                            } }))] }) }) }) }));
}
